module.exports = __webpack_public_path__ + "img/iconofficeactive.af352d56.svg";